import React from 'react';
import { Link } from 'react-router-dom';
import { Button, SectionContainer } from '@/components';
import { formatMessage } from '@/locales';
import './home-content-capybara.view.less';
import { LocalStorageService } from '@/services';
import Tool from '@/components/tool/tool';

const HomeContent0View = () => {
    const localId = LocalStorageService.get('localId') || 'en-US';
    const logonText = {
        'en-US': require('@/assets/img/home/capybara/capy_logo_en@2x.png'),
        'zh-CN': require('@/assets/img/home/capybara/capy_logo_cn@2x.png')
    };

    return (
        <SectionContainer
            className="home-content-capybara-view"
            imageRender={() => {
                return (
                    <picture>
                        <source
                            srcSet={require('@/assets/img/home/capybara/home_page_capy_background_m@2x.png')}
                            media="(max-width: 768px)"
                        />
                        <img
                            className="background-image"
                            src={require('@/assets/img/home/capybara/home_page_capy_background@2x.png')}
                            alt=""
                        />
                    </picture>
                );
            }}
        >
            {/* <div className="new">
                <img src={newImage} alt="" />
            </div> */}
            <div className="contents">
                <div className="title">
                    <span className="logo-wrapper">
                        <img src={logonText[localId]} alt="" />
                    </span>
                    
                    {/* <span className="text">
                        {formatMessage({ id: 'home.content0.name' })}
                    </span> */}
                </div>
                {/* <div className="google-play-wrapper">
                    <img src={GooglePlayImage} alt="" />
                </div> */}
                <p className="desc">
                    {formatMessage({ id: 'home.content.capybara.description' })}
                </p>
                <Tool
                    appleurl="https://apps.apple.com/app/capybara-go/id6596787726"
                    googleplayurl="https://play.google.com/store/apps/details?id=com.habby.capybara"
                    detailPageId="capybara"
                />
            </div>
        </SectionContainer>
    );
};

export default HomeContent0View;
